module.exports = __webpack_public_path__ + "img/people_highlight_modal_background.1db75889.png";